export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553596190/Aylin/kapak7aylinB976.jpg'
];